export default function AbzarhaVaTajhizatSingle({ type = 1, label, data, handleCheck }) {
    const isActive = data[label];
    return (
        <>
            {type == 1 ?
                <div
                    className={`${isActive ? "bg-green-600 !text-white" : "bg-white"} text-[14px] text-[#333333] transition-all duration-200 ease-in-out select-none flex cursor-pointer p-2 justify-center border`}
                    onClick={handleCheck}
                >
                    {label}
                </div> :
                <div
                    className={`${isActive ? "bg-blue-900 !text-white" : "bg-white"} text-[14px] text-[#333333] transition-all duration-200 ease-in-out select-none flex cursor-pointer p-2 justify-center border`}
                    onClick={handleCheck}
                >
                    {label}
                </div>
            }
        </>


    )
}